'use client';
import { createContext, useContext } from 'react';

export type UserLocaleOverrideContextType = {
  locale?: string;
};

const DEFAULT_CONTEXT: UserLocaleOverrideContextType = {
  locale: undefined,
};

export const UserLocaleOverrideContext =
  createContext<UserLocaleOverrideContextType>(DEFAULT_CONTEXT);

export const useUserLocaleOverride = () => {
  const context = useContext(UserLocaleOverrideContext);

  if (!context) {
    return DEFAULT_CONTEXT;
  }

  return context;
};
